import EditorLink from 'lowcode/components/EditorLink';
import styles from './index.module.scss';
import { NoticesIcon } from '@/components/UI/svg/Ecocredits';
import getLocal from '@/app/utils/getLocal';
import { useGlobal } from '@/utils/useGlobal';
import { i18nMap } from '@/constants/i18n';

const EcocreditsRuleAnnounce = () => {
    const { useLang } = useGlobal();
    const { t } = useLang('ecocredits');
    const { locale } = getLocal();
    return (
        <div className={`${styles.EcocreditsRuleAnnounce}`}>
            <div className="content">
                <span className="notice-icon">
                    <NoticesIcon />
                </span>
                <span className="notice-text">
                    {t.rich('ecocredits_notice1', {
                        line1: (text: string) => (
                            <EditorLink
                                className="link-text"
                                href={`https://account.ecoflow.com/agreement/${i18nMap[locale]}/EcoCredits-Rewards-Terms-Conditions.html`}
                                target="_blank"
                                rel="noreferrer"
                            >
                                {text}
                            </EditorLink>
                        ),
                    })}
                </span>
            </div>
        </div>
    );
};

export default EcocreditsRuleAnnounce;
